import axios from "axios";
import { NEVER_OWNED_APIS } from "../Config/apiConfig";

/**
 * Fetches available protection plans from the API.
 * @returns {{ success: boolean, data: Array, error: string|null }}
 */
export const getPlansAction = async () => {
  try {
    const response = await axios.get(NEVER_OWNED_APIS.GET_PLANS, {
      headers: { Accept: "application/json" },
    });

    // console.log("GET PLANS RESPONSE:", response.data);

    if (response.data?.success && Array.isArray(response.data?.data)) {
      return { success: true, data: response.data.data, error: null };
    }

    return {
      success: false,
      data: [],
      error: response.data?.message || "No plans returned from server.",
    };
  } catch (error) {
    console.error("GET PLANS ERROR:", error);
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to load protection plans.";
    return { success: false, data: [], error: errorMessage };
  }
};
